module.exports = __webpack_public_path__ + "img/w3_circle_trash_delete_white.2246f7f0.png";